import React, { PropsWithChildren } from "react";
import { PulsingGreeter } from "./PulsingGreeter";

import css from "./LoadingOverlay.module.scss";
import { AnimatePresence, motion } from "motion/react";

export type LoadingOverlayProps = PropsWithChildren & {
  message?: React.ReactNode;
  style?: React.CSSProperties;
};

export function LoadingOverlay(props: LoadingOverlayProps) {
  return (
    <AnimatePresence>
      {props.message && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={css.LoadingOverlay}
          style={props.style}
        >
          {props.children ? (
            props.children
          ) : (
            <motion.div
              initial={{ y: 10 }}
              animate={{ y: 0 }}
              exit={{ y: 10 }}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <PulsingGreeter /> {props.message ?? "Henter..."}
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
